// src/components/AuthProvider.jsx
import { GoogleOAuthProvider } from '@react-oauth/google';

const AuthProvider = ({ children }) => {
    return (
        <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
            {children}
        </GoogleOAuthProvider>
    );
};

export default AuthProvider;